import classnames from 'classnames';
import React from 'react';

import TRANSLATIONS from './translations@default.json';

const HighDemandMessaging = ({ classes }) => (
	<div className={classnames(classes, 'bg-highlight p-4 rounded')}>
		<h3 className="text-body-xs font-bold text-primary">
			{TRANSLATIONS.title}
		</h3>
		{TRANSLATIONS.paragraphs.map((paragraph) => (
			<p
				className="mt-2 text-body-xs text-primary"
				key={paragraph.substring(0, 5)}>
				{paragraph}
			</p>
		))}
	</div>
);

export default HighDemandMessaging;
